import api from '../../../../api/client';

export const MONTH_OPTIONS = [
  { value: 'Jan', label: 'Jan' },
  { value: 'Feb', label: 'Feb' },
  { value: 'Mar', label: 'Mar' },
  { value: 'Apr', label: 'Apr' },
  { value: 'May', label: 'May' },
  { value: 'Jun', label: 'Jun' },
  { value: 'Jul', label: 'Jul' },
  { value: 'Aug', label: 'Aug' },
  { value: 'Sep', label: 'Sep' },
  { value: 'Oct', label: 'Oct' },
  { value: 'Nov', label: 'Nov' },
  { value: 'Dec', label: 'Dec' },
];

export const LEAVE_SETTING_OPTIONS = [
  { value: 'Monthly Credit Leaves', label: 'Monthly Credit Leaves' },
  { value: 'Yearly Credit Leaves', label: 'Yearly Credit Leaves' },
];

function mapSettings(s) {
  return {
    id: s.id || s.ID || 1,
    payrollStartDate: s.payroll_start_date || s.PayrollStartDate || s.payrollStartDate || '2026-04-01',
    payrollStartDateDisplay: s.payrollStartDateDisplay || s.PayrollStartDateDisplay || '01/04/2026',
    payrollYearEndMonth: s.payroll_year_end_month || s.PayrollYearEndMonth || s.payrollYearEndMonth || 'Mar',
    payrollLeaveSetting: s.payroll_leave_setting || s.PayrollLeaveSetting || s.payrollLeaveSetting || 'Monthly Credit Leaves',
    allowLeaveOverAvailable: Boolean(s.allow_leave_over_available ?? s.AllowLeaveOverAvailable ?? s.allowLeaveOverAvailable),
    updatedBy: s.updated_by || s.UpdatedBy || null,
    updatedByName: s.updated_by_name || s.UpdatedByName || '',
    updatedOn: s.updated_on || s.UpdatedOn || null,
  };
}

export const payrollSettingsApi = {
  getSettings: async () => {
    try {
      const { data } = await api.get('/payroll/settings/');
      return mapSettings(data);
    } catch (e) {
      console.warn('Failed to fetch payroll settings from backend, using fallback', e);
      return {
        id: 1,
        payrollStartDate: '2026-04-01',
        payrollStartDateDisplay: '01/04/2026',
        payrollYearEndMonth: 'Mar',
        payrollLeaveSetting: 'Monthly Credit Leaves',
        allowLeaveOverAvailable: false,
        updatedBy: null,
        updatedByName: '',
        updatedOn: null,
      };
    }
  },

  saveSettings: async (settings) => {
    const payload = {
      payroll_start_date: settings.payrollStartDate || '2026-04-01',
      payroll_year_end_month: settings.payrollYearEndMonth || 'Mar',
      payroll_leave_setting: settings.payrollLeaveSetting || 'Monthly Credit Leaves',
      allow_leave_over_available: Boolean(settings.allowLeaveOverAvailable),
    };
    const { data } = await api.post('/payroll/settings/', payload);
    return { success: true, data: mapSettings(data) };
  },
};
